/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContent } from './FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContent';
import {
    FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentFromJSON,
    FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentFromJSONTyped,
    FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentToJSON,
    FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentToJSONTyped,
} from './FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContent';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto
 */
export interface FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto {
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto
     */
    Id: number;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto
     */
    Url: string;
    /**
     * 
     * @type {FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContent}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto
     */
    Content?: FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContent | null;
    /**
     * 
     * @type {Date}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto
     */
    CreatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto
     */
    DocumentId: number;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto interface.
 */
export function instanceOfFxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto(value: object): value is FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto {
    if (!('Id' in value) || value['Id'] === undefined) return false;
    if (!('Url' in value) || value['Url'] === undefined) return false;
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined) return false;
    if (!('DocumentId' in value) || value['DocumentId'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoFromJSON(json: any): FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto {
    return FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'Id': json['Id'],
        'Url': json['Url'],
        'Content': json['Content'] == null ? undefined : FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentFromJSON(json['Content']),
        'CreatedAt': (new Date(json['CreatedAt'])),
        'DocumentId': json['DocumentId'],
    };
}

export function FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoToJSON(json: any): FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto {
    return FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoToJSONTyped(json, false);
}

export function FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoToJSONTyped(value?: FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Id': value['Id'],
        'Url': value['Url'],
        'Content': FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoContentToJSON(value['Content']),
        'CreatedAt': ((value['CreatedAt']).toISOString()),
        'DocumentId': value['DocumentId'],
    };
}

